import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { useEmailLogsList } from '@/features/logs-management/email-logs/hooks/useEmailLogsList';
import { EmailLogsTable } from '@/features/logs-management/email-logs/table';
import { Translation } from '@/hoslog-intl';
import { EmailIcon } from '@/icons/email-icon';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum(['emailResourceId', 'message', 'createdDate', 'emailSentBy', 'emailSentTo', 'emailSentStatus']),
  desc: z.boolean(),
});

const emailLogsSchema = z
  .object({
    sort: z
      .preprocess((val) => {
        if (typeof val === 'string') {
          try {
            return JSON.parse(val);
          } catch {
            return undefined;
          }
        }
        return val;
      }, z.array(sortItemSchema))
      .optional(),

    createdDate: z
      .string()

      .optional(),

    q: z.string().optional(),

    status: z
      .string()
      .transform((val) => val.split(','))
      .pipe(z.array(z.enum(['ACTIVE', 'INACTIVE'])))
      .optional(),

    page: z.coerce.number().positive().catch(0),
    fetch: z.coerce.number().positive().max(100).catch(10),
  })
  .passthrough();

export const Route = createFileRoute('/(app)/logs-management/email-logs/')({
  loader: () => {
    return {
      crumb: <CrumbTitle id="logsManagement.emailLogs.crumb.emailLogs" icon={EmailIcon} />,
      title: <Translation id="logsManagement.emailLogs.crumb.emailLogs" />,
    };
  },
  errorComponent: ({ error }) => {
    return <div>{error.message}</div>;
  },
  component: RouteComponent,
  validateSearch: (search: SearchSchemaInput) => emailLogsSchema.parse(search),
});

function RouteComponent() {
  const { emailLogs, isLoading, pagination } = useEmailLogsList();
  return <EmailLogsTable data={emailLogs} isLoading={isLoading} pagination={pagination} />;
}
